import { type SerializedError } from '@databases/types';
import { type KnownUser } from '@databases/types/confluence';

import { createSlice, type PayloadAction } from '../../shims/redux-toolkit.ts';
import { type AsyncOperation, AsyncOperationStatus } from '../async-operation.ts';

export interface UsersState {
  users: Record<string, KnownUser>;
  userByIdStatus: Record<string, AsyncOperation<void>>;
}

const initialState: UsersState = {
  users: {},
  userByIdStatus: {}
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    loadUserByIdPending: (state, action: PayloadAction<{ accountId: string }>) => {
      const { accountId } = action.payload;

      state.userByIdStatus[accountId] = { status: AsyncOperationStatus.PENDING };
    },

    loadUserByIdFinished: (state, action: PayloadAction<{ accountId: string }>) => {
      const { accountId } = action.payload;

      state.userByIdStatus[accountId] = { status: AsyncOperationStatus.SUCCEEDED };
    },

    loadUserByIdError: (
      state,
      action: PayloadAction<{ accountId: string; error: SerializedError }>
    ) => {
      const { accountId, error } = action.payload;

      state.userByIdStatus[accountId] = { status: AsyncOperationStatus.ERROR, error };
    },

    addUsersToList: (state, action: PayloadAction<{ users: KnownUser[] }>) => {
      const { users } = action.payload;

      for (const user of users) {
        state.users[user.accountId] = user;
      }
    },

    deleteUsersFromList: (state, action: PayloadAction<{ accountIds: string[] }>) => {
      const { accountIds } = action.payload;

      for (const accountId of accountIds) {
        delete state.users[accountId];
      }
    }
  }
});

export default usersSlice;
